import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.025 16" width="1em" height="1em" {...props}><path d="M2.06 2C.937 2 0 2.936 0 4.06v7.891h1.037v-1.015H2V6.06C2 6.01 2.01 6 2.06 6h11.905c.05 0 .06.01.06.06v7.981h.934l.045-1.06h1.021V4.06c0-1.125-.936-2.061-2.06-2.061zm7.95 2.074h3.976v.928H10.01z" style={{
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1,
      marker: "none"
    }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" fill="#2e3436" /></svg>;
}

export default SvgComponent;